<template>
  <div class="document-container">
    <div v-if="!saved && !readOnly" class="row">
      <div class="col-md-6 pt-0">
        <div class="color-secondary-6 font-16 d-block">
          Documento:
        </div>
        <span class="text-format">{{ title }}</span>
      </div>
      <div class="col-md-6">
        <div class="d-flex align-items-center">
          <validation-provider
            v-slot="{ errors }"
            name="Archivo"
            rules="required"
          >
            <div class="color-secondary-6 font-16 d-block">
              Archivo:
            </div>
            <custom-file-input
              ref="attachedDocument"
              v-model="document"
              :accept="allowedFiles"
              class="custom-file-input__extended"
              custom-error-msg="Favor de anejar el documento."
              display-style="normal"
              :error="errors[0]"
              label=""
              label-position="left"
              required
              @input="handleChangeFile"
            />
          </validation-provider>
          <action-button
            v-if="canShowCancel"
            class="mt-4 ml-3"
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger"
            @click="cancel"
          />
        </div>
      </div>
      <div class="col-12 mt-3 mt-md-2 d-flex justify-content-end">
        <action-button
          v-if="false"
          i="fa fa-file-plus"
          text="Añadir"
          variant="success"
          @click="saveDocument"
        />
      </div>
    </div>
    <div v-else class="row align-items-center">
      <div class="col-12 col-md-10">
        <div class="color-secondary-6 font-16 d-block">{{ title }}:</div>
        <span v-if="data" class="text-format">{{ data.name }}</span>
      </div>
      <div v-if="!readOnly" class="col-12 col-md-2 text-right">
        <drop-down class="documents-action" :items="actionItems" />
      </div>
      <div v-else>
        <action-button
          class="mt-4 ml-3"
          i="fas fa-file-download"
          text=""
          variant="outline-success"
          @click="downloadFile"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import DropDown from 'dropdown';
import CustomFileInput from '@/components/common/CustomFileInput';
import _generalApi from '@/modules/app/api';

export default {
  name: 'InterventionPlanSignatureDocument',
  components: {
    ActionButton,
    DropDown,
    CustomFileInput,
  },
  props: {
    data: {
      type: Object,
      default: () => null,
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
    saved: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      default: () => 'Plan de Intervención Firmado',
    },
  },
  data: () => ({
    document: null,
    allowedFiles: '.pdf',
  }),
  computed: {
    actionItems() {
      return [
        {
          name: 'edit',
          label: 'Editar',
          icon: 'fas fa-edit color-primary-1',
          click: () => this.editDocument(),
          visible:
            (!this.data.documentId ||
              (this.data.documentId &&
                this.userHasPermissions(
                  'interventionplan.canchangedocument'
                ))) &&
            !this.readOnly,
        },
        {
          btnClass: 'outline-success',
          icon: 'fas fa-file-download color-primary-1',
          label: 'Descargar',
          visible: this.data.documentId != null,
          click: () => this.downloadFile(),
        },
      ];
    },
    canShowCancel() {
      return !!this.data?.documentId;
    },
  },
  methods: {
    async validate() {
      return await this.$refs.formRef.validate();
    },
    handleChangeFile(file) {
      if (file) {
        this.$nextTick(() => {
          this.document = file;
          this.saveDocument();
        });
      } else {
        this.cancel();
      }
    },
    saveDocument(documentSaved = false) {
      this.$emit('save-document', this.document, documentSaved);
    },
    editDocument() {
      this.$emit('edit-document');
    },
    clear() {
      this.document = null;
      this.$emit('cancel-document', false);
    },
    cancel() {
      if (this.data && this.data.file) {
        this.document = this.data.file;
        this.$emit('cancel-document', true);
        return;
      }
      this.document = null;
      this.$emit('cancel-document', false);
    },
    async downloadFile() {
      await _generalApi
        .downloadDocumentByAttachmentId(this.data.documentId)
        .catch(() => {
          this.ShowToast('', 'El documento no existe.', 'error');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.document-container {
  padding: 0 0.8rem;
  ::v-deep &__text-area {
    .small-counter {
      font-size: 0.8rem;
      color: map-get($colors, 'gray-6');
    }
  }

  .input-display {
    font-size: 0.875rem;
    color: map-get($colors, 'gray-6');
    font-weight: bold;
  }

  .text-format {
    overflow-wrap: break-word;
    text-align: justify;
  }

  @media only screen and (max-width: 768px) {
    ::v-deep .documents-action {
      .btn {
        margin-top: 0.8rem;
        width: 100%;
      }
    }
  }
}

::v-deep .custom-file-input__extended {
  width: 500px;
}
</style>
